import permissions from "./index";
import {useState, useEffect} from "react";

const HasPermission = (props) => {
    const {children, match} = props;
    const [neededPermissions, setNeededPermissions] = useState([]);
    const [hasPermission, setHasPermission] = useState(false);

    useEffect(() => {
        if (props.permission) {
            // console.log(props.permission)
            setNeededPermissions(Array.isArray(props.permission) ? props.permission : [props.permission]);
        }
    }, [props.permission]);

    useEffect(() => {
        if (neededPermissions.length > 0) {
            checkPermissions().then((res) => {
                const allNull = res.every((p) => p === null);
                if (res.length > 0 && !allNull) {
                    if (match === 'any') {
                        setHasPermission(res.some((p) => p === true));
                    } else {
                        setHasPermission(res.every((p) => p === true));
                    }
                } else {
                    setHasPermission(true);
                }

            });
        } else {
            setHasPermission(true);
        }
    }, [neededPermissions]);

    const checkPermissions = async () => {
        const response = [];
        const res = await Promise.all(neededPermissions.map(async (permission) => {
            const check = await checkPermission(permission);
            response.push({
                permission: permission,
                hasPermission: check
            });

            if (check === null) {
                //console.log(`Permission ${permission} not found`);
            }

            return check;
        }));

        return res;
    }

    const checkPermission = (permission) => {
        return new Promise(async (resolve, reject) => {
            const p = permission.replace('.', ':');
            const permissionModule = p.split(':')[0];
            if (await permissions.moduleExists(permissionModule) === true) {
                const res = await permissions.action(p);
                resolve(res);
            } else {
                resolve(null);
            }
        });
    }

    return (
        <>
            {hasPermission ?
                children
                :
                <>
                    {props.else && props.else}
                </>
            }
        </>
    )
}

export default HasPermission;